export default "__VITE_ASSET__DZAD0WU8__"